export default __webpack_public_path__ + "static/media/greenGke.bc57a9a9.svg";